import React from 'react'
import styled from "styled-components"
import {motion} from "framer-motion"
export default function Framer() {
  return (
    <DIV>
        <div>
            
            
        <motion.h1  animate={{
            fontSize: 50,
            scale: 1.5,
            // x:100,
            y:100
        }}>
            hello world
        </motion.h1>
        Framer
            </div>

    </DIV>
  )
}

const DIV = styled.div`

border: 1px solid black;
text-align: center;

`
